import React from 'react';
import { MessageSquareX, Hourglass, Scale } from 'lucide-react';
export function FailedMethods() {
  const methods = [{
    icon: <MessageSquareX className="w-8 h-8 text-zinc-500" data-id="element-38" />,
    title: 'La Confrontación',
    description: "Hablar 'para aclarar' solo te dejó más herido. Buscabas paz y encontraste más excusas."
  }, {
    icon: <Hourglass className="w-8 h-8 text-zinc-500" data-id="element-39" />,
    title: 'El Tiempo',
    description: 'El tiempo no cura, solo fermenta el rencor si no hay un cierre activo y consciente.'
  }, {
    icon: <Scale className="w-8 h-8 text-zinc-500" data-id="element-40" />,
    title: 'La Justicia Externa',
    description: "Esperar que el 'Karma' actúe te mantiene encadenado al agresor, esperando su caída en lugar de tu vuelo."
  }];
  return <section className="py-24 px-4 bg-zinc-900/30" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-serif text-zinc-100 mb-4" data-id="element-44">
            Por qué los métodos tradicionales fallan
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto" data-id="element-45">
            Has intentado soltar, pero las herramientas que te dieron estaban
            diseñadas para mantenerte atado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-46">
          {methods.map((method, index) => <div key={index} className="bg-zinc-950 border border-zinc-800/50 p-8 hover:border-amber-500/30 transition-colors duration-300 group" data-id="element-47">
              <div className="mb-6 opacity-50 group-hover:opacity-100 group-hover:text-amber-500 transition-all duration-300" data-id="element-48">
                {method.icon}
              </div>
              <h3 className="text-xl text-zinc-200 mb-3 font-serif" data-id="element-49">
                {method.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-50">
                {method.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}